import { render, staticRenderFns } from "./clueInfo.vue?vue&type=template&id=0700de7c&scoped=true"
import script from "./clueInfo.vue?vue&type=script&lang=js"
export * from "./clueInfo.vue?vue&type=script&lang=js"
import style0 from "./clueInfo.vue?vue&type=style&index=0&id=0700de7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700de7c",
  null
  
)

export default component.exports